import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router';
import {
  CrossCircleIcon,
  EmployeeCalculatingIconSvg,
  EmployeesGraphicIconSvg,
  EmployeeWaitingIconSvg
} from '../../../lib/icons';
import { useTranslation } from 'react-i18next';
import { SupportedExportTypes } from '../store/exportFlowStore';
import { Button } from '../../../lib/components/atomic/button';

export const ExportConclusion = observer(() => {
  const navigate = useNavigate();
  const { type } = useParams();
  const { t } = useTranslation();

  const img: Record<SupportedExportTypes, ReactNode> = {
    employee_data: <EmployeesGraphicIconSvg />,
    receipts: <EmployeeWaitingIconSvg />,
    payroll_data: <EmployeeCalculatingIconSvg />,
    voucher_orders: <EmployeeCalculatingIconSvg />,
    usc_memberships: <EmployeeWaitingIconSvg />,
    edenred_amounts: <EmployeeWaitingIconSvg />
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="100%"
    >
      {type ? (
        img[type as SupportedExportTypes]
      ) : (
        <CrossCircleIcon color="grey.100" height={50} width={50} />
      )}
      <Typography
        variant="subtitle1"
        fontSize="1.5rem"
        color="heaven.main"
        marginTop="3rem"
        marginBottom="1rem"
      >
        {t('export:CREATED')}
      </Typography>
      <Button variant="tertiary" className="mt-8" onClick={() => navigate('/exports')}>
        {t('export:BACK_TO_OVERVIEW')}
      </Button>
    </Box>
  );
});
